//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
	}
	//#endregion

	return {
		outerStyle: ({mt, bgColor = '#FFC107', color = 'black'} = {}) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				backgroundColor: bgColor,
				padding: `0 ${minimumMarginX}rem 2.5rem ${minimumMarginX}rem`,
				marginTop: mt ? '3rem' : 'unset',
				color: color,
			};
		},
		textStyle: () => {
			return {
				marginTop: '2.5rem',
			};
		},
	};
}

export default Styles;
